
<tr v-if="display">
<td>{{ household }}</td>
<td>{{ accountNum }}</td>
<td>{{ lastCash }}</td>
<td>{{ grandTotal }}</td>
</tr>
